/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import qs from 'qs'

export type CheckoutSessionCreationErrorResponseType =
  (typeof CheckoutSessionCreationErrorResponseType)[keyof typeof CheckoutSessionCreationErrorResponseType]

export const CheckoutSessionCreationErrorResponseType = {
  MICROBIOME_TEST_REQUIRES_PLUS: 'MICROBIOME_TEST_REQUIRES_PLUS',
  ALREADY_ZOE_PLUS_MEMBER: 'ALREADY_ZOE_PLUS_MEMBER',
  EMAIL_REQUIRED: 'EMAIL_REQUIRED',
  COUNTRY_MISMATCH: 'COUNTRY_MISMATCH',
  CHECKOUT_VALIDATION_ERROR: 'CHECKOUT_VALIDATION_ERROR',
  MEMBER_NOT_ACTIVE: 'MEMBER_NOT_ACTIVE',
  ALREADY_HAS_ACTIVE_OR_PAUSED_D30_SUBSCRIPTION: 'ALREADY_HAS_ACTIVE_OR_PAUSED_D30_SUBSCRIPTION',
  ALREADY_HAS_ACTIVE_OR_PAUSED_BARS_SUBSCRIPTION: 'ALREADY_HAS_ACTIVE_OR_PAUSED_BARS_SUBSCRIPTION',
  BARS_QUANTITY_EXCEEDED: 'BARS_QUANTITY_EXCEEDED',
  BARS_QUANTITY_BELOW_MINIMUM: 'BARS_QUANTITY_BELOW_MINIMUM',
  PAID_TRIAL_NOT_AVAILABLE: 'PAID_TRIAL_NOT_AVAILABLE',
  ALREADY_HAD_SUBSCRIPTION_CANNOT_PURCHASE_TRIAL: 'ALREADY_HAD_SUBSCRIPTION_CANNOT_PURCHASE_TRIAL',
  ALREADY_HAD_WELCOME_OFFER: 'ALREADY_HAD_WELCOME_OFFER',
  PRICE_NOT_LIVE: 'PRICE_NOT_LIVE',
  NO_CURRENT_OFFERING_IN_BASKET: 'NO_CURRENT_OFFERING_IN_BASKET',
  PRICE_CURRENCY_MISMATCH: 'PRICE_CURRENCY_MISMATCH',
  UNEARNED_FREE_ITEM: 'UNEARNED_FREE_ITEM',
  NO_STRIPE_CUSTOMER: 'NO_STRIPE_CUSTOMER',
  GIFT_BASKET_MISMATCH: 'GIFT_BASKET_MISMATCH',
  GIFT_ORDER_NOT_REDEEMABLE: 'GIFT_ORDER_NOT_REDEEMABLE',
} as const

export interface CheckoutSessionCreationErrorResponse {
  type: CheckoutSessionCreationErrorResponseType
  message: string
}

export interface MoveBillingRequest {
  new_billing_date: string
}

export interface Address {
  city: string
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code: string
  line1: string
  /** @nullable */
  line2?: string | null
  postal_code: string
  /** @nullable */
  state?: string | null
}

export interface PriceBreakdown {
  /** @nullable */
  amount?: number | null
  total: number
  subtotal: number
  shipping_total: number
  currency: string
  discount_total: number
  tax_total: number
}

export interface Recurring {
  interval: string
  interval_count: number
}

export type PriceProductType = (typeof PriceProductType)[keyof typeof PriceProductType]

export const PriceProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  BARS: 'BARS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  PROGRAM: 'PROGRAM',
  KIT: 'KIT',
  UNKNOWN_FALLBACK: 'UNKNOWN_FALLBACK',
} as const

export type IntroOfferType = (typeof IntroOfferType)[keyof typeof IntroOfferType]

export const IntroOfferType = {
  TRIAL: 'TRIAL',
  WELCOME_OFFER: 'WELCOME_OFFER',
} as const

export type PriceMetadata = { [key: string]: string }

export interface Price {
  /** @nullable */
  id?: string | null
  lookup_key: string
  nickname: string
  currency: string
  active: boolean
  unit_amount: number
  product_type: PriceProductType
  tax_behavior: string
  recurring?: Recurring | null
  /** @nullable */
  product_name?: string | null
  /** @nullable */
  product_image?: string | null
  metadata: PriceMetadata
  is_fee: boolean
  intro_offer_type?: IntroOfferType | null
}

export interface SubscriptionItem {
  /** @nullable */
  id?: string | null
  price: Price
  current_period_start: string
  current_period_end: string
  quantity: number
}

export interface BillingCycleDetails {
  start: string
  end: string
  price_breakdown: PriceBreakdown
  frequency?: Recurring | null
  items: SubscriptionItem[]
}

/**
 * @nullable
 */
export type CouponMetadata = { [key: string]: string } | null

export interface Coupon {
  id: string
  /** @nullable */
  name?: string | null
  is_valid: boolean
  /** @nullable */
  metadata?: CouponMetadata
}

export interface Customer {
  id: string
  /** @nullable */
  first_name?: string | null
  /** @nullable */
  last_name?: string | null
  /** @nullable */
  full_name?: string | null
  email: string
  shipping_address?: Address | null
}

export interface PromotionCode {
  id: string
  code: string
  coupon: Coupon
  is_active: boolean
}

export interface Discount {
  /** @nullable */
  id?: string | null
  coupon?: Coupon | null
  promotion_code?: PromotionCode | null
}

export type PauseCollectionBehavior = (typeof PauseCollectionBehavior)[keyof typeof PauseCollectionBehavior]

export const PauseCollectionBehavior = {
  VOID: 'VOID',
  KEEP_AS_DRAFT: 'KEEP_AS_DRAFT',
  MARK_UNCOLLECTIBLE: 'MARK_UNCOLLECTIBLE',
} as const

export interface PauseCollection {
  behavior: PauseCollectionBehavior
  /** @nullable */
  resumes_at?: string | null
}

export type SubscriptionProductType = (typeof SubscriptionProductType)[keyof typeof SubscriptionProductType]

export const SubscriptionProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  BARS: 'BARS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  PROGRAM: 'PROGRAM',
  KIT: 'KIT',
  UNKNOWN_FALLBACK: 'UNKNOWN_FALLBACK',
} as const

export type SubscriptionStatus = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus]

export const SubscriptionStatus = {
  INCOMPLETE: 'INCOMPLETE',
  INCOMPLETE_EXPIRED: 'INCOMPLETE_EXPIRED',
  ACTIVE: 'ACTIVE',
  PAST_DUE: 'PAST_DUE',
  CANCELED: 'CANCELED',
  UNPAID: 'UNPAID',
} as const

export type SubscriptionMetadata = { [key: string]: string }

export interface SubscriptionScheduleCurrentPhase {
  start_date: string
  end_date: string
}

export interface SubscriptionSchedulePhaseDefaultTaxRate {
  id: string
  inclusive: boolean
}

export interface SubscriptionSchedulePhaseDiscount {
  /** @nullable */
  coupon_id?: string | null
  /** @nullable */
  discount_id?: string | null
  /** @nullable */
  promotion_code_id?: string | null
}

export interface SubscriptionSchedulePhaseItemTaxRate {
  id: string
  inclusive: boolean
}

export interface SubscriptionSchedulePhaseItem {
  price_id: string
  price?: Price | null
  /** @nullable */
  tax_rates?: SubscriptionSchedulePhaseItemTaxRate[] | null
  quantity: number
}

export interface SubscriptionSchedulePhaseAutomaticTax {
  enabled: boolean
}

export type SubscriptionSchedulePhaseMetadata = { [key: string]: string }

export interface SubscriptionSchedulePhase {
  currency: string
  /** @nullable */
  default_tax_rates?: SubscriptionSchedulePhaseDefaultTaxRate[] | null
  discounts: SubscriptionSchedulePhaseDiscount[]
  start_date: string
  end_date: string
  items: SubscriptionSchedulePhaseItem[]
  metadata: SubscriptionSchedulePhaseMetadata
  /** @nullable */
  trial_end?: string | null
  automatic_tax?: SubscriptionSchedulePhaseAutomaticTax | null
}

export type SubscriptionScheduleStatus = (typeof SubscriptionScheduleStatus)[keyof typeof SubscriptionScheduleStatus]

export const SubscriptionScheduleStatus = {
  ACTIVE: 'ACTIVE',
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  NOT_STARTED: 'NOT_STARTED',
  RELEASED: 'RELEASED',
} as const

export type SubscriptionScheduleEndBehavior =
  (typeof SubscriptionScheduleEndBehavior)[keyof typeof SubscriptionScheduleEndBehavior]

export const SubscriptionScheduleEndBehavior = {
  CANCEL: 'CANCEL',
  RELEASE: 'RELEASE',
} as const

export type SubscriptionScheduleMetadata = { [key: string]: string }

export interface SubscriptionSchedule {
  id: string
  current_phase?: SubscriptionScheduleCurrentPhase | null
  customer_id: string
  customer?: Customer | null
  metadata: SubscriptionScheduleMetadata
  phases: SubscriptionSchedulePhase[]
  status: SubscriptionScheduleStatus
  /** @nullable */
  subscription_id?: string | null
  /** @nullable */
  canceled_at?: string | null
  /** @nullable */
  completed_at?: string | null
  end_behavior: SubscriptionScheduleEndBehavior
  /** @nullable */
  released_at?: string | null
  /** @nullable */
  released_subscription?: string | null
}

export type TrialInfoTrialType = (typeof TrialInfoTrialType)[keyof typeof TrialInfoTrialType]

export const TrialInfoTrialType = {
  NONE: 'NONE',
  PAID_PRO_RATA: 'PAID_PRO_RATA',
  ONE_TIME_AND_TRIAL_SUBSCRIPTION: 'ONE_TIME_AND_TRIAL_SUBSCRIPTION',
} as const

/**
 * @nullable
 */
export type TrialInfoStatus = (typeof TrialInfoStatus)[keyof typeof TrialInfoStatus] | null

export const TrialInfoStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  CONVERTED: 'CONVERTED',
  CANCELLED: 'CANCELLED',
} as const

export interface TrialInfo {
  trial_type: TrialInfoTrialType
  /** @nullable */
  start_date?: string | null
  /** @nullable */
  end_date?: string | null
  trial_duration_string: string
  /** @nullable */
  status?: TrialInfoStatus
  intro_offer_type: IntroOfferType
}

export interface Subscription {
  id: string
  customer_id: string
  product_type: SubscriptionProductType
  /**
   * Use lastBilledCycle.frequency instead.
   * @deprecated
   */
  frequency?: Recurring | null
  status: SubscriptionStatus
  /**
   * Use lastBilledCycle.items instead.
   * @deprecated
   */
  items: SubscriptionItem[]
  /** @nullable */
  billing_cycle_anchor?: string | null
  created_at: string
  cancel_at_period_end: boolean
  /** @nullable */
  cancel_at?: string | null
  /** @nullable */
  canceled_at?: string | null
  /** @nullable */
  commitment_end_date?: string | null
  /** @nullable */
  ended_at?: string | null
  /** @nullable */
  schedule_id?: string | null
  /**
   * Use lastBilledCycle and upcomingBillingCycle instead.
   * @deprecated
   */
  schedule?: SubscriptionSchedule | null
  pause_collection?: PauseCollection | null
  metadata: SubscriptionMetadata
  discounts: Discount[]
  trial_info?: TrialInfo | null
  last_billed_cycle: BillingCycleDetails
  upcoming_billing_cycle: BillingCycleDetails
  billed_currency: string
}

export interface SubscriptionItemInput {
  price_lookup_key: string
  price?: Price | null
  quantity: number
}

export interface ModifySubscriptionItemsRequest {
  items: SubscriptionItemInput[]
  idempotency_key: string
}

export interface CheckoutLineItem {
  /** @nullable */
  id?: string | null
  product_id: string
  quantity: number
}

export interface UpdateCheckoutSessionRequest {
  session_id: string
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code: string
  basket: CheckoutLineItem[]
}

export interface LineItem {
  id: string
  price: Price
  amount_discount: number
  amount_subtotal: number
  amount_total: number
  amount_tax: number
  billing_description: string
  /** @nullable */
  billing_interval?: string | null
  /** @nullable */
  billing_interval_count?: number | null
  quantity: number
}

export interface UpdateCheckoutSessionResponse {
  session_id: string
  basket: LineItem[]
}

export interface RedeemPromoCodeRequest {
  promo_code_id: string
}

export interface ValidRange {
  /** @nullable */
  starts_at?: string | null
  /** @nullable */
  ends_at?: string | null
}

/**
 * The fields of a gift rule that may change after it is created
 */
export interface UpdateGiftRuleRequest {
  active: boolean
  valid_range?: ValidRange | null
  /**
   * Replaces the rules this one conflicts with; omit it to keep the current set, send [] to clear it
   * @nullable
   */
  blocked_by_gift_rule_ids?: string[] | null
}

export interface ExperimentAllocation {
  experiment_key: string
  /** @nullable */
  variant?: string | null
}

export interface GiftLineItem {
  gift_identifier: string
  quantity: number
}

export type GiftRuleQualifyingPurchaseTypesItem =
  (typeof GiftRuleQualifyingPurchaseTypesItem)[keyof typeof GiftRuleQualifyingPurchaseTypesItem]

export const GiftRuleQualifyingPurchaseTypesItem = {
  NEW_ORDER: 'NEW_ORDER',
  TRIAL: 'TRIAL',
  TRIAL_CONVERSION: 'TRIAL_CONVERSION',
  RENEWAL: 'RENEWAL',
} as const

export type LineItemMatcherProductType = (typeof LineItemMatcherProductType)[keyof typeof LineItemMatcherProductType]

export const LineItemMatcherProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  BARS: 'BARS',
  SCOOP: 'SCOOP',
  TIN: 'TIN',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  PAMPHLET: 'PAMPHLET',
} as const

/**
 * @nullable
 */
export type LineItemMatcherProductVariant =
  | (typeof LineItemMatcherProductVariant)[keyof typeof LineItemMatcherProductVariant]
  | null

export const LineItemMatcherProductVariant = {
  ORIGINAL: 'ORIGINAL',
  RASPBERRY_GOJI: 'RASPBERRY_GOJI',
  DARK_CHOCOLATE_SALT: 'DARK_CHOCOLATE_SALT',
  DAILY30_WELCOME: 'DAILY30_WELCOME',
} as const

/**
 * @nullable
 */
export type LineItemMatcherProductUnit =
  | (typeof LineItemMatcherProductUnit)[keyof typeof LineItemMatcherProductUnit]
  | null

export const LineItemMatcherProductUnit = {
  SINGLE: 'SINGLE',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  MONTHLY_POUCH: 'MONTHLY_POUCH',
  SINGLE_SERVE_SACHET: 'SINGLE_SERVE_SACHET',
  TWELVE_BAR_BOX: 'TWELVE_BAR_BOX',
} as const

export type LineItemMatcherQuantityOperator =
  (typeof LineItemMatcherQuantityOperator)[keyof typeof LineItemMatcherQuantityOperator]

export const LineItemMatcherQuantityOperator = {
  EQUAL_TO: 'EQUAL_TO',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL_TO: 'GREATER_THAN_OR_EQUAL_TO',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_OR_EQUAL_TO: 'LESS_THAN_OR_EQUAL_TO',
} as const

export interface LineItemMatcher {
  product_type: LineItemMatcherProductType
  /** @nullable */
  product_variant?: LineItemMatcherProductVariant
  /** @nullable */
  product_unit?: LineItemMatcherProductUnit
  /** @nullable */
  quantity?: number | null
  quantity_operator: LineItemMatcherQuantityOperator
}

export interface RenewalCondition {
  exact_cycles: number[]
  /** @nullable */
  cadence?: number | null
  starting_cycle: number
  /** @nullable */
  max_cycle?: number | null
}

/**
 * A stored gift rule
 */
export interface GiftRule {
  /** @nullable */
  id?: string | null
  rule_name: string
  qualifying_purchase_types: GiftRuleQualifyingPurchaseTypesItem[]
  requires_all_of: LineItemMatcher[]
  renewal_condition?: RenewalCondition | null
  gift_line_items: GiftLineItem[]
  checkout_price_lookup_keys: string[]
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @nullable
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code?: string | null
  experiment?: ExperimentAllocation | null
  /** @nullable */
  starts_at?: string | null
  /** @nullable */
  ends_at?: string | null
  blocked_by_gift_rule_ids: string[]
  active: boolean
  priority: number
  /** @nullable */
  max_redemptions?: number | null
}

export interface SwitchOnRenewalResponsePhaseDetail {
  start_date: string
  price_name: string
  price_lookup_key: string
}

export interface SwitchOnRenewalResponse {
  phase_details: SwitchOnRenewalResponsePhaseDetail[]
}

export interface CancelSubscriptionRequest {
  reason: string
}

export interface CancelledSubscriptionDetails {
  end_date: string
  in_allowed_cancellation_window: boolean
  /** @nullable */
  is_bundled_with_gut_health_test?: boolean | null
}

export type CancellationDiscountDuration =
  (typeof CancellationDiscountDuration)[keyof typeof CancellationDiscountDuration]

export const CancellationDiscountDuration = {
  ONCE: 'ONCE',
  REPEATING: 'REPEATING',
} as const

export interface CancellationDiscount {
  /** @nullable */
  percent_off?: number | null
  /** @nullable */
  amount_off?: number | null
  /** @nullable */
  currency?: string | null
  duration: CancellationDiscountDuration
  /** @nullable */
  duration_in_months?: number | null
}

/**
 * @nullable
 */
export type CreateCheckoutSessionRequestMarketingConsent =
  | (typeof CreateCheckoutSessionRequestMarketingConsent)[keyof typeof CreateCheckoutSessionRequestMarketingConsent]
  | null

export const CreateCheckoutSessionRequestMarketingConsent = {
  OPTIN: 'OPTIN',
  OPTOUT: 'OPTOUT',
  NOCHANGE: 'NOCHANGE',
} as const

/**
 * The checkout layout variant to use. Determines which Elements-based Stripe checkout experience is rendered (CUSTOM or CUSTOM_EXPRESS). Defaults to CUSTOM if not provided.
 * @nullable
 */
export type CreateCheckoutSessionRequestLayout =
  | (typeof CreateCheckoutSessionRequestLayout)[keyof typeof CreateCheckoutSessionRequestLayout]
  | null

export const CreateCheckoutSessionRequestLayout = {
  CUSTOM_EXPRESS: 'CUSTOM_EXPRESS',
  CUSTOM: 'CUSTOM',
} as const

export interface CreateCheckoutSessionRequest {
  /** @nullable */
  products?: string[] | null
  basket: CheckoutLineItem[]
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code: string
  return_url: string
  /** @nullable */
  marketing_consent?: CreateCheckoutSessionRequestMarketingConsent
  /** @nullable */
  email?: string | null
  /**
   * A Stripe promotion code id (not human readable coupon) to apply to the checkout session.
   * @nullable
   */
  promotion_code_id?: string | null
  /**
   * The checkout layout variant to use. Determines which Elements-based Stripe checkout experience is rendered (CUSTOM or CUSTOM_EXPRESS). Defaults to CUSTOM if not provided.
   * @nullable
   */
  layout?: CreateCheckoutSessionRequestLayout
  /**
   * The instant of when the frontend purchase incentive decision timer ends
   * @nullable
   */
  incentive_decision_timer_end?: string | null
  /**
   * The experiments the caller is allocated to. Saved on the order subscription once the checkout completes.
   * @nullable
   */
  experiments?: ExperimentAllocation[] | null
}

/**
 * @nullable
 */
export type CreateCheckoutSessionResponsePaymentMethodConstraint =
  | (typeof CreateCheckoutSessionResponsePaymentMethodConstraint)[keyof typeof CreateCheckoutSessionResponsePaymentMethodConstraint]
  | null

export const CreateCheckoutSessionResponsePaymentMethodConstraint = {
  CARD_STANDARD: 'CARD_STANDARD',
  CARD_APPLE: 'CARD_APPLE',
  CARD_GPAY: 'CARD_GPAY',
  KLARNA: 'KLARNA',
} as const

export interface CreateCheckoutSessionResponse {
  session_id: string
  client_secret: string
  line_items: LineItem[]
  /** @nullable */
  payment_method_constraint?: CreateCheckoutSessionResponsePaymentMethodConstraint
}

export interface CheckoutEligibilityRequest {
  basket: CheckoutLineItem[]
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code: string
  /** @nullable */
  email?: string | null
}

export type CreateGifterCheckoutSessionRequestTheme =
  (typeof CreateGifterCheckoutSessionRequestTheme)[keyof typeof CreateGifterCheckoutSessionRequestTheme]

export const CreateGifterCheckoutSessionRequestTheme = {
  BIRTHDAY: 'BIRTHDAY',
  CHRISTMAS: 'CHRISTMAS',
  MOTHERS_DAY: 'MOTHERS_DAY',
  DEFAULT: 'DEFAULT',
} as const

export interface CreateGifterCheckoutSessionRequest {
  /** One-time prices only: a recurring price or trial fee is rejected with a 422. */
  basket: CheckoutLineItem[]
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code: string
  return_url: string
  /** The gifter's email; the Stripe session is created for it. */
  gifter_email: string
  /** When the gift email goes to the receiver. The gift is redeemable for six months from then. */
  send_at: string
  /** The receiver's email. */
  send_to: string
  from_name: string
  to_name: string
  /**
   * Optional message shown in the gift email, at most 256 characters.
   * @maxLength 256
   * @nullable
   */
  custom_message?: string | null
  theme: CreateGifterCheckoutSessionRequestTheme
  /** Base of the gift email link to the page where the receiver redeems the gift; the gift order id is appended as a path segment: <redeemBaseUrl>/<id>. */
  redeem_base_url: string
}

export interface ExpressCheckoutRequest {
  basket: CheckoutLineItem[]
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code: string
  return_url: string
  /** @nullable */
  promotion_code_id?: string | null
}

export interface ReconcileInvoiceMetadataRequest {
  invoice_id: string
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code: string
}

export type ReconcileInvoiceMetadataResponseStatus =
  (typeof ReconcileInvoiceMetadataResponseStatus)[keyof typeof ReconcileInvoiceMetadataResponseStatus]

export const ReconcileInvoiceMetadataResponseStatus = {
  UPDATED: 'UPDATED',
  SKIPPED: 'SKIPPED',
  FAILED: 'FAILED',
} as const

export interface ReconcileInvoiceMetadataResponse {
  invoice_id: string
  /** @nullable */
  order_number?: string | null
  status: ReconcileInvoiceMetadataResponseStatus
  /** @nullable */
  reason?: string | null
}

export interface BackfillSubscriptionRequest {
  subscription_id: string
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code: string
}

export interface BackfillSubscriptionResponse {
  subscription_id: string
  order_number: string
  billing_cycles: number
  renewal_count: number
}

export interface CreateLinearTicketRequest {
  title: string
  description: string
}

export type CreateGiftRuleRequestQualifyingPurchaseTypesItem =
  (typeof CreateGiftRuleRequestQualifyingPurchaseTypesItem)[keyof typeof CreateGiftRuleRequestQualifyingPurchaseTypesItem]

export const CreateGiftRuleRequestQualifyingPurchaseTypesItem = {
  NEW_ORDER: 'NEW_ORDER',
  TRIAL: 'TRIAL',
  TRIAL_CONVERSION: 'TRIAL_CONVERSION',
  RENEWAL: 'RENEWAL',
} as const

/**
 * A gift rule to store. Rules are created inactive
 */
export interface CreateGiftRuleRequest {
  rule_name: string
  qualifying_purchase_types: CreateGiftRuleRequestQualifyingPurchaseTypesItem[]
  requires_all_of: LineItemMatcher[]
  renewal_condition?: RenewalCondition | null
  gift_line_items: GiftLineItem[]
  checkout_price_lookup_keys: string[]
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @nullable
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code?: string | null
  experiment?: ExperimentAllocation | null
  /** @nullable */
  starts_at?: string | null
  /** @nullable */
  ends_at?: string | null
  blocked_by_gift_rule_ids: string[]
  /** Which rule wins when two rules block each other; the higher priority is kept */
  priority: number
  /**
   * How many times the rule may be applied to one subscription; omit it for no limit
   * @nullable
   */
  max_redemptions?: number | null
}

export type ApplicableGiftsRequestPurchaseTypesItem =
  (typeof ApplicableGiftsRequestPurchaseTypesItem)[keyof typeof ApplicableGiftsRequestPurchaseTypesItem]

export const ApplicableGiftsRequestPurchaseTypesItem = {
  NEW_ORDER: 'NEW_ORDER',
  TRIAL: 'TRIAL',
  TRIAL_CONVERSION: 'TRIAL_CONVERSION',
  RENEWAL: 'RENEWAL',
} as const

export type PaidItemProductType = (typeof PaidItemProductType)[keyof typeof PaidItemProductType]

export const PaidItemProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  BARS: 'BARS',
  SCOOP: 'SCOOP',
  TIN: 'TIN',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  PAMPHLET: 'PAMPHLET',
} as const

export type PaidItemProductVariant = (typeof PaidItemProductVariant)[keyof typeof PaidItemProductVariant]

export const PaidItemProductVariant = {
  ORIGINAL: 'ORIGINAL',
  RASPBERRY_GOJI: 'RASPBERRY_GOJI',
  DARK_CHOCOLATE_SALT: 'DARK_CHOCOLATE_SALT',
  DAILY30_WELCOME: 'DAILY30_WELCOME',
} as const

export type PaidItemUnit = (typeof PaidItemUnit)[keyof typeof PaidItemUnit]

export const PaidItemUnit = {
  SINGLE: 'SINGLE',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  MONTHLY_POUCH: 'MONTHLY_POUCH',
  SINGLE_SERVE_SACHET: 'SINGLE_SERVE_SACHET',
  TWELVE_BAR_BOX: 'TWELVE_BAR_BOX',
} as const

export interface ProductUnitPrice {
  minor_units: number
  currency: string
}

export interface PaidItem {
  product_type: PaidItemProductType
  product_variant: PaidItemProductVariant
  unit: PaidItemUnit
  quantity: number
  unit_price?: ProductUnitPrice | null
}

/**
 * The purchase to evaluate gift rules against
 */
export interface ApplicableGiftsRequest {
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code: string
  purchase_types: ApplicableGiftsRequestPurchaseTypesItem[]
  paid_items: PaidItem[]
  /** @nullable */
  renewal_cycle?: number | null
  experiments: ExperimentAllocation[]
  /** One entry per time a rule was applied; a rule applied twice appears twice */
  applied_gift_rule_ids: string[]
}

export interface PromotionCodeCreationRequest {
  code: string
  /** @nullable */
  max_redemptions?: number | null
  /** @nullable */
  assigned_to_username?: string | null
  first_time_transaction_only: boolean
  /** @nullable */
  expiry_date?: string | null
}

export interface CheckoutSessionCompletedTrigger {
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code: string
  checkout_session_id: string
  event_timestamp: number
  subscription_id: string
}

export type RefundStatus = (typeof RefundStatus)[keyof typeof RefundStatus]

export const RefundStatus = {
  PENDING: 'PENDING',
  REQUIRES_ACTION: 'REQUIRES_ACTION',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  CANCELED: 'CANCELED',
} as const

export interface Refund {
  id: string
  amount: number
  currency: string
  created: string
  status: RefundStatus
}

/**
 * Why this subscription cannot switch plan. Null when a switch is allowed.
 * @nullable
 */
export type SwitchOptionsResponseCannotSwitchReason =
  | (typeof SwitchOptionsResponseCannotSwitchReason)[keyof typeof SwitchOptionsResponseCannotSwitchReason]
  | null

export const SwitchOptionsResponseCannotSwitchReason = {
  SUBSCRIPTION_NOT_ACTIVE: 'SUBSCRIPTION_NOT_ACTIVE',
  PENDING_CANCELLATION: 'PENDING_CANCELLATION',
  MULTIPLE_ITEMS: 'MULTIPLE_ITEMS',
  PRODUCT_TYPE_NOT_SWITCHABLE: 'PRODUCT_TYPE_NOT_SWITCHABLE',
} as const

/**
 * The plans a subscription can switch to, or why it cannot switch at all
 */
export interface SwitchOptionsResponse {
  /**
   * Why this subscription cannot switch plan. Null when a switch is allowed.
   * @nullable
   */
  cannot_switch_reason?: SwitchOptionsResponseCannotSwitchReason
  /** Prices this subscription can switch to, longest billing period first. Empty when a switch is blocked, and also when nothing in the catalogue is a valid target. */
  options: Price[]
}

export type CancellationInterventionType =
  (typeof CancellationInterventionType)[keyof typeof CancellationInterventionType]

export const CancellationInterventionType = {
  DAILY30_1M_BENEFITS: 'DAILY30_1M_BENEFITS',
  DAILY30_4M_BENEFITS: 'DAILY30_4M_BENEFITS',
  PROGRAM_BENEFITS: 'PROGRAM_BENEFITS',
  ZOE_PLUS_3M_BENEFITS: 'ZOE_PLUS_3M_BENEFITS',
  ZOE_PLUS_12M_BENEFITS: 'ZOE_PLUS_12M_BENEFITS',
  BARS_1M_BENEFITS: 'BARS_1M_BENEFITS',
  DAILY30_1M_DELAY: 'DAILY30_1M_DELAY',
  DAILY30_4M_DELAY: 'DAILY30_4M_DELAY',
  BARS_1M_DELAY: 'BARS_1M_DELAY',
  DAILY30_1M_SWITCH_PLAN: 'DAILY30_1M_SWITCH_PLAN',
  DAILY30_4M_SWITCH_PLAN: 'DAILY30_4M_SWITCH_PLAN',
  ZOE_PLUS_1M_SWITCH_PLAN: 'ZOE_PLUS_1M_SWITCH_PLAN',
  ZOE_PLUS_3M_SWITCH_PLAN: 'ZOE_PLUS_3M_SWITCH_PLAN',
  ZOE_PLUS_12M_SWITCH_PLAN: 'ZOE_PLUS_12M_SWITCH_PLAN',
  DAILY30_1M_DISCOUNT: 'DAILY30_1M_DISCOUNT',
  DAILY30_4M_DISCOUNT: 'DAILY30_4M_DISCOUNT',
  ZOE_PLUS_1M_DISCOUNT: 'ZOE_PLUS_1M_DISCOUNT',
  ZOE_PLUS_3M_DISCOUNT: 'ZOE_PLUS_3M_DISCOUNT',
  ZOE_PLUS_12M_DISCOUNT: 'ZOE_PLUS_12M_DISCOUNT',
} as const

export type CancellationInterventionData = { [key: string]: unknown }

export type CancellationInterventionCategory =
  (typeof CancellationInterventionCategory)[keyof typeof CancellationInterventionCategory]

export const CancellationInterventionCategory = {
  BENEFITS: 'BENEFITS',
  DELAY: 'DELAY',
  SWITCH_PLAN: 'SWITCH_PLAN',
  DISCOUNT: 'DISCOUNT',
} as const

export interface CancellationIntervention {
  type: CancellationInterventionType
  data: CancellationInterventionData
  category: CancellationInterventionCategory
}

export interface CancellationInterventionsResponse {
  interventions: CancellationIntervention[]
}

export type ListSubscriptionStatus = (typeof ListSubscriptionStatus)[keyof typeof ListSubscriptionStatus]

export const ListSubscriptionStatus = {
  ALL: 'ALL',
  ACTIVE: 'ACTIVE',
  CANCELED: 'CANCELED',
  ENDED: 'ENDED',
  INCOMPLETE: 'INCOMPLETE',
  INCOMPLETE_EXPIRED: 'INCOMPLETE_EXPIRED',
  PAST_DUE: 'PAST_DUE',
  UNPAID: 'UNPAID',
} as const

export interface OrderSubscription {
  subscription: Subscription
  order_number: string
}

export type GetCheckoutSessionDetailsResponseStatus =
  (typeof GetCheckoutSessionDetailsResponseStatus)[keyof typeof GetCheckoutSessionDetailsResponseStatus]

export const GetCheckoutSessionDetailsResponseStatus = {
  COMPLETE: 'COMPLETE',
  EXPIRED: 'EXPIRED',
  OPEN: 'OPEN',
} as const

/**
 * @nullable
 */
export type GetCheckoutSessionDetailsResponsePaymentMethodType =
  | (typeof GetCheckoutSessionDetailsResponsePaymentMethodType)[keyof typeof GetCheckoutSessionDetailsResponsePaymentMethodType]
  | null

export const GetCheckoutSessionDetailsResponsePaymentMethodType = {
  CARD_STANDARD: 'CARD_STANDARD',
  CARD_APPLE: 'CARD_APPLE',
  CARD_GPAY: 'CARD_GPAY',
  KLARNA: 'KLARNA',
} as const

export interface GetCheckoutSessionDetailsResponse {
  session_id: string
  customer: Customer
  status: GetCheckoutSessionDetailsResponseStatus
  line_items: LineItem[]
  amount_total: number
  amount_subtotal: number
  amount_tax: number
  amount_discount: number
  /** @nullable */
  promotion_code?: string | null
  /** @nullable */
  payment_method_type?: GetCheckoutSessionDetailsResponsePaymentMethodType
}

/**
 * The reason why the user cannot purchase this product bundle. Null if canPurchase is true.
 * @nullable
 */
export type ProductAvailabilityReason =
  | (typeof ProductAvailabilityReason)[keyof typeof ProductAvailabilityReason]
  | null

export const ProductAvailabilityReason = {
  ALREADY_OWNED: 'ALREADY_OWNED',
  ALREADY_HAD_TRIAL: 'ALREADY_HAD_TRIAL',
  ALREADY_HAD_WELCOME_OFFER: 'ALREADY_HAD_WELCOME_OFFER',
  OWNS_CLASSIC_MEMBERSHIP: 'OWNS_CLASSIC_MEMBERSHIP',
  DOES_NOT_OWN_ZOE_PLUS: 'DOES_NOT_OWN_ZOE_PLUS',
  NOT_AVAILABLE_IN_COUNTRY: 'NOT_AVAILABLE_IN_COUNTRY',
} as const

/**
 * Details about whether a product can be purchased by the user
 */
export interface ProductAvailability {
  /** Whether the user can purchase this product bundle */
  can_purchase: boolean
  /**
   * The reason why the user cannot purchase this product bundle. Null if canPurchase is true.
   * @nullable
   */
  reason?: ProductAvailabilityReason
}

export interface FetchPricesResponse {
  prices: Price[]
}

export type GiftDetailsResponseStatus = (typeof GiftDetailsResponseStatus)[keyof typeof GiftDetailsResponseStatus]

export const GiftDetailsResponseStatus = {
  STARTED: 'STARTED',
  PAID: 'PAID',
  REDEEMED: 'REDEEMED',
} as const

export type GiftDetailsResponseTheme = (typeof GiftDetailsResponseTheme)[keyof typeof GiftDetailsResponseTheme]

export const GiftDetailsResponseTheme = {
  BIRTHDAY: 'BIRTHDAY',
  CHRISTMAS: 'CHRISTMAS',
  MOTHERS_DAY: 'MOTHERS_DAY',
  DEFAULT: 'DEFAULT',
} as const

export interface GiftDetailsResponse {
  gift_order_id: string
  status: GiftDetailsResponseStatus
  /** True when the gift is paid, its email was sent and it hasn't expired yet. */
  is_redeemable: boolean
  theme: GiftDetailsResponseTheme
  from_name: string
  to_name: string
  /** @nullable */
  custom_message?: string | null
  /** The gift basket; the receiver's checkout must match it exactly. */
  basket: CheckoutLineItem[]
  /**
   * The gift's single-use promotion code id, only while the gift is redeemable.
   * @nullable
   */
  promotion_code_id?: string | null
  valid_until: string
}

export interface PublicCustomerResponse {
  username: string
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code: string
}

export interface BillingPortal {
  url: string
}

export interface GetSubscriptionsResponse {
  subscriptions: OrderSubscription[]
}

export interface AvailablePricesResponse {
  available_prices: Price[]
}

export interface CustomerResponse {
  stripe_customer_id: string
  username: string
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code: string
}

export interface CustomerListResponse {
  customers: CustomerResponse[]
}

export interface DisputeDetails {
  date: string
  status: string
  reason: string
}

export interface FailureDetails {
  /** @nullable */
  decline_code?: string | null
  /** @nullable */
  doc_url?: string | null
  /** @nullable */
  reason_showed_to_user?: string | null
  /** @nullable */
  next_retry_date?: string | null
}

export interface RefundDetails {
  amount: number
  currency: string
  date: string
  status: string
}

export interface PastPayment {
  payment_date: string
  amount: number
  currency: string
  /** @nullable */
  refund_details?: RefundDetails[] | null
  failure_details?: FailureDetails | null
  dispute_details?: DisputeDetails | null
  payment_purpose: string
  /** @nullable */
  instalment_count?: number | null
}

export interface UpcomingPayment {
  /** @nullable */
  payment_date?: string | null
  amount: number
  currency: string
  payment_purpose: string
  /** @nullable */
  instalment_count?: number | null
}

export interface PaymentsSummary {
  past: PastPayment[]
  upcoming: UpcomingPayment[]
}

export type ChargeStatus = (typeof ChargeStatus)[keyof typeof ChargeStatus]

export const ChargeStatus = {
  SUCCEEDED: 'SUCCEEDED',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
} as const

export interface Charge {
  id: string
  amount: number
  currency: string
  refunded: boolean
  status: ChargeStatus
  amount_captured: number
  amount_refunded: number
  created: string
  additional_info: string[]
  /** @nullable */
  disputed?: boolean | null
  /** @nullable */
  refunds?: Refund[] | null
}

export type RedeemPromoCodeForSubscriptionParams = {
  username: string
}

export type MovePhysicalProductSubscriptionBillingDateBySubscriptionIdParams = {
  username: string
}

export type PrivateModifySubscriptionItemsParams = {
  username: string
}

export type HandleWebhooksParams = {
  api_version: string
}

export type HandleWebhooks1Params = {
  api_version: string
}

export type SwitchPlanBySubscriptionIdParams = {
  targetPlan: string
}

export type CreateOneClickCheckoutParams = {
  /**
   * The Stripe session the member just paid with. Omit it for a signed-in member, in which case the Stripe customer is resolved from the member's own customer record.
   */
  referenceSessionId?: string
}

export type PrivateSwitchPlanBySubscriptionIdParams = {
  username: string
  targetPlan: string
}

export type PrivateCancelParams = {
  username: string
}

export type ReinstateAutoRenewalBySubscriptionIdParams = {
  username: string
}

export type CancelImmediatelyBySubscriptionIdParams = {
  username: string
}

export type PrivateApplyDiscountParams = {
  username: string
}

export type SearchGiftsParams = {
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  countryCode?: string
  isActive?: boolean
  isValidDateRange?: boolean
}

export type CreatePromotionCodeForCouponParams = {
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  countryCode: string
}

export type RefundChargeParams = {
  refundAmount?: number
}

export type GetSubscriptionByIdParams = {
  includeDiscounts?: boolean
  includeSchedule?: boolean
  includeUpcomingInvoicePreview?: boolean
}

export type GetSubscriptionsParams = {
  subscriptionStatus?: ListSubscriptionStatus
  priceProductType?: GetSubscriptionsPriceProductType
  includeSchedule?: boolean
  includeDiscounts?: boolean
  includeUpcomingInvoicePreview?: boolean
}

export type GetSubscriptionsPriceProductType =
  (typeof GetSubscriptionsPriceProductType)[keyof typeof GetSubscriptionsPriceProductType]

export const GetSubscriptionsPriceProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  BARS: 'BARS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  PROGRAM: 'PROGRAM',
  KIT: 'KIT',
  UNKNOWN_FALLBACK: 'UNKNOWN_FALLBACK',
} as const

export type GetSubscriptions1Params = {
  subscriptionStatus?: ListSubscriptionStatus
  priceProductType?: GetSubscriptions1PriceProductType
  includeSchedule?: boolean
  includeDiscounts?: boolean
  includeUpcomingInvoicePreview?: boolean
}

export type GetSubscriptions1PriceProductType =
  (typeof GetSubscriptions1PriceProductType)[keyof typeof GetSubscriptions1PriceProductType]

export const GetSubscriptions1PriceProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  BARS: 'BARS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  PROGRAM: 'PROGRAM',
  KIT: 'KIT',
  UNKNOWN_FALLBACK: 'UNKNOWN_FALLBACK',
} as const

export type GetCheckoutSessionDetailsParams = {
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  country_code: string
  session_id: string
  email?: string
}

export type GetProductsAvailabilityParams = {
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  countryCode?: string
}

export type GetProductsAvailability200 = { [key: string]: ProductAvailability }

export type FetchPublicPricesParams = {
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  countryCode: string
  productType?: FetchPublicPricesProductType
  lookupKeys?: string[]
  visible?: boolean
  live?: boolean
  switchable?: boolean
}

export type FetchPublicPricesProductType =
  (typeof FetchPublicPricesProductType)[keyof typeof FetchPublicPricesProductType]

export const FetchPublicPricesProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  BARS: 'BARS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  PROGRAM: 'PROGRAM',
  KIT: 'KIT',
  UNKNOWN_FALLBACK: 'UNKNOWN_FALLBACK',
} as const

export type GetUserAvailablePricesParams = {
  productType: GetUserAvailablePricesProductType
  lookupKeys?: string[]
  visible?: boolean
  live?: boolean
  switchable?: boolean
}

export type GetUserAvailablePricesProductType =
  (typeof GetUserAvailablePricesProductType)[keyof typeof GetUserAvailablePricesProductType]

export const GetUserAvailablePricesProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  BARS: 'BARS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  PROGRAM: 'PROGRAM',
  KIT: 'KIT',
  UNKNOWN_FALLBACK: 'UNKNOWN_FALLBACK',
} as const

export type FilterUserSubscriptionsParams = {
  username: string
  subscriptionStatus?: ListSubscriptionStatus
  priceProductType?: FilterUserSubscriptionsPriceProductType
  includeSchedule?: boolean
  includeDiscounts?: boolean
}

export type FilterUserSubscriptionsPriceProductType =
  (typeof FilterUserSubscriptionsPriceProductType)[keyof typeof FilterUserSubscriptionsPriceProductType]

export const FilterUserSubscriptionsPriceProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  BARS: 'BARS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  PROGRAM: 'PROGRAM',
  KIT: 'KIT',
  UNKNOWN_FALLBACK: 'UNKNOWN_FALLBACK',
} as const

export type PrivateGetSubscriptionByIdParams = {
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  countryCode?: string
  username?: string
  includeDiscounts?: boolean
  includeSchedule?: boolean
}

export type PrivateGetSwitchOptionsParams = {
  username: string
}

export type PrivateGetInterventionsParams = {
  username: string
}

export type GetProductsAvailability1Params = {
  username?: string
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  countryCode?: string
}

export type GetProductsAvailability1200 = { [key: string]: ProductAvailability }

export type PrivateFilterPricesParams = {
  lookupKeys?: string[]
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  countryCode?: string
  productType?: PrivateFilterPricesProductType
  username?: string
  visible?: boolean
  live?: boolean
  switchable?: boolean
}

export type PrivateFilterPricesProductType =
  (typeof PrivateFilterPricesProductType)[keyof typeof PrivateFilterPricesProductType]

export const PrivateFilterPricesProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  BARS: 'BARS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  PROGRAM: 'PROGRAM',
  KIT: 'KIT',
  UNKNOWN_FALLBACK: 'UNKNOWN_FALLBACK',
} as const

export type PrivateGetAvailablePricesParams = {
  zoeProductType: PrivateGetAvailablePricesZoeProductType
  username: string
}

export type PrivateGetAvailablePricesZoeProductType =
  (typeof PrivateGetAvailablePricesZoeProductType)[keyof typeof PrivateGetAvailablePricesZoeProductType]

export const PrivateGetAvailablePricesZoeProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  BARS: 'BARS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  PROGRAM: 'PROGRAM',
  KIT: 'KIT',
  UNKNOWN_FALLBACK: 'UNKNOWN_FALLBACK',
} as const

export type SearchCustomersParams = {
  stripeCustomerIds: string[]
}

export type GetLastRefundableChargeParams = {
  productType: GetLastRefundableChargeProductType
}

export type GetLastRefundableChargeProductType =
  (typeof GetLastRefundableChargeProductType)[keyof typeof GetLastRefundableChargeProductType]

export const GetLastRefundableChargeProductType = {
  ZOE_PLUS: 'ZOE_PLUS',
  GUT_MICROBIOME_TEST: 'GUT_MICROBIOME_TEST',
  DAILY30: 'DAILY30',
  ZOE_LUNCHBOX: 'ZOE_LUNCHBOX',
  ZOE_TRAVEL_POUCH: 'ZOE_TRAVEL_POUCH',
  BARS: 'BARS',
  SHIPPING_FEE: 'SHIPPING_FEE',
  PROGRAM: 'PROGRAM',
  KIT: 'KIT',
  UNKNOWN_FALLBACK: 'UNKNOWN_FALLBACK',
} as const

export type DeletePromotionCodeParams = {
  /**
   * ISO 3166-1 alpha-2 country code - see supported countries in `com.joinzoe.rapide.country.ZoeCountry`
   * @pattern ^[a-zA-Z]{2}$
   */
  countryCode: string
}

export const getPaymentServiceClient = (axiosInstance: AxiosInstance = axios) => {
  /**
   * Move billing date for a subscription of a physical product. At the moment we only support Daily30 subscriptions.
   * @summary Move billing date for a subscription of a physical product.
   */
  const movePhysicalProductSubscriptionBillingDate = (
    subscriptionId: string,
    moveBillingRequest: MoveBillingRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Subscription>> => {
    return axiosInstance.put(`/public/subscription/${subscriptionId}/move-billing-date`, moveBillingRequest, options)
  }

  /**
   * Overwrites the subscription's items with the provided list. If the subscription has no schedule the change applies directly to the subscription. If a schedule exists the change applies to the phase after the current phase.
   * @summary Modify items on a subscription.
   */
  const modifySubscriptionItems = (
    subscriptionId: string,
    modifySubscriptionItemsRequest: ModifySubscriptionItemsRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Subscription>> => {
    return axiosInstance.put(`/public/subscription/${subscriptionId}/items`, modifySubscriptionItemsRequest, options)
  }

  /**
   * Same server-side liveness gates as session creation: every basket price must be `metadata.live = "true"` and the basket must retain at least one visible-and-live price.
   * @summary Update an open Stripe Checkout Session's line items
   */
  const updateCheckoutSession = (
    updateCheckoutSessionRequest: UpdateCheckoutSessionRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<UpdateCheckoutSessionResponse>> => {
    return axiosInstance.put(`/public/session`, updateCheckoutSessionRequest, options)
  }

  /**
   * Every basket price must be tagged `metadata.live = "true"`, and the basket must contain at least one visible-and-live price. Both are enforced server-side and are not client-controllable: non-live baskets are rejected with PRICE_NOT_LIVE / NO_CURRENT_OFFERING_IN_BASKET.
   * @summary Create a Stripe Checkout Session
   */
  const createCheckoutSession = (
    createCheckoutSessionRequest: CreateCheckoutSessionRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CreateCheckoutSessionResponse>> => {
    return axiosInstance.post(`/public/session`, createCheckoutSessionRequest, options)
  }

  /**
   * Apply a promo code to a subscription, marking it as redeemed and replacing it for its backing coupon.
   * @summary Apply a promo code to an existing subscription.
   */
  const redeemPromoCodeForSubscription = (
    subscriptionId: string,
    redeemPromoCodeRequest: RedeemPromoCodeRequest,
    params: RedeemPromoCodeForSubscriptionParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Subscription>> => {
    return axiosInstance.put(`/private/subscription/${subscriptionId}/redeem-promo-code`, redeemPromoCodeRequest, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Move billing date for a subscription of a physical product by subscription id.
   */
  const movePhysicalProductSubscriptionBillingDateBySubscriptionId = (
    subscriptionId: string,
    moveBillingRequest: MoveBillingRequest,
    params: MovePhysicalProductSubscriptionBillingDateBySubscriptionIdParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Subscription>> => {
    return axiosInstance.put(`/private/subscription/${subscriptionId}/move-billing-date`, moveBillingRequest, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Modify items on a subscription by subscription id.
   */
  const privateModifySubscriptionItems = (
    subscriptionId: string,
    modifySubscriptionItemsRequest: ModifySubscriptionItemsRequest,
    params: PrivateModifySubscriptionItemsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Subscription>> => {
    return axiosInstance.put(`/private/subscription/${subscriptionId}/items`, modifySubscriptionItemsRequest, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Replace the mutable fields of a gift rule: whether it is active, its window and its exclusions
   */
  const updateGift = (
    id: string,
    updateGiftRuleRequest: UpdateGiftRuleRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<GiftRule>> => {
    return axiosInstance.put(`/private/gifts/${id}`, updateGiftRuleRequest, options)
  }

  const handleWebhooks = (
    handleWebhooksBody: string,
    params: HandleWebhooksParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(`/public/webhook/stripe/`, handleWebhooksBody, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  const handleWebhooks1 = (
    handleWebhooks1Body: string,
    params: HandleWebhooks1Params,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(`/public/webhook/stripe`, handleWebhooks1Body, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * Schedule a plan switch on the given subscription renewal. Supports Daily30 and ZOE_PLUS.
   * @summary Switches the given subscription's plan
   */
  const switchPlanBySubscriptionId = (
    subscriptionId: string,
    params: SwitchPlanBySubscriptionIdParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<SwitchOnRenewalResponse>> => {
    return axiosInstance.post(`/public/subscription/${subscriptionId}/switch-plan`, undefined, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Cancel a subscription using the appropriate methodology based on the subscription type
   */
  const cancel = (
    subscriptionId: string,
    cancelSubscriptionRequest: CancelSubscriptionRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CancelledSubscriptionDetails>> => {
    return axiosInstance.post(`/public/subscription/${subscriptionId}/cancel`, cancelSubscriptionRequest, options)
  }

  /**
   * @summary Reinstate auto-renewal for a cancelled subscription by subscription id
   */
  const reinstateAutoRenewal = (
    subscriptionId: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Subscription>> => {
    return axiosInstance.post(
      `/public/subscription/${subscriptionId}/cancel/reinstate-auto-renewal`,
      undefined,
      options,
    )
  }

  /**
   * Immediately cancels a subscription with no refund. Prefer the /cancel endpoint which selects the appropriate cancellation strategy based on subscription type.
   * @summary Cancel a subscription immediately by subscription id
   */
  const cancelImmediateBySubscriptionId = (
    subscriptionId: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Subscription>> => {
    return axiosInstance.post(`/public/subscription/${subscriptionId}/cancel/immediate`, undefined, options)
  }

  /**
   * The discount is resolved from the subscription's own plan, so the client never names a coupon.
   * @summary Apply the cancellation-save discount to a subscription
   */
  const applyDiscount = (
    subscriptionId: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CancellationDiscount>> => {
    return axiosInstance.post(`/public/subscription/${subscriptionId}/cancel/discount`, undefined, options)
  }

  /**
   * Purchase-eligibility check at `POST /public/session/eligibility`, run before the session it gates. Identity comes from the (anonymous or authenticated) Firebase JWT; a guest passes `email`. The JSON body is `{ basket: [{ productId, quantity }], countryCode, email? }`. Returns 200 when the caller may proceed, 409 when the email owns an existing account or subscription, and 422 (CheckoutSessionCreationError) for a business-rule ineligibility. It creates no session and runs no stripe-level basket validation.
   * @summary Check whether the caller may buy this basket
   */
  const checkEligibility = (
    checkoutEligibilityRequest: CheckoutEligibilityRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(`/public/session/eligibility`, checkoutEligibilityRequest, options)
  }

  /**
   * Creates a one-time Stripe Checkout Session for the gifter and records the gift order with the gift email to send. The basket gets the same stripe-level validation as session creation, but no eligibility, gifts, shipping fee or trial.
   * @summary Create a gifter checkout session for a cross customer gift
   */
  const createGifterCheckoutSession = (
    createGifterCheckoutSessionRequest: CreateGifterCheckoutSessionRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CreateCheckoutSessionResponse>> => {
    return axiosInstance.post(`/public/gift-checkout/session`, createGifterCheckoutSessionRequest, options)
  }

  /**
   * @summary Send the cross customer gift emails whose send date has passed
   */
  const sendDueGiftEmails = (options?: AxiosRequestConfig): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(`/public/gift-checkout/send-due-gift-emails`, undefined, options)
  }

  /**
   * @summary Create a one-click checkout session that reuses a Stripe customer the caller already has
   */
  const createOneClickCheckout = (
    expressCheckoutRequest: ExpressCheckoutRequest,
    params?: CreateOneClickCheckoutParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CreateCheckoutSessionResponse>> => {
    return axiosInstance.post(`/public/checkout/one-click-checkout`, expressCheckoutRequest, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  const backfillInvoiceOrderNumbers = (
    reconcileInvoiceMetadataRequest: ReconcileInvoiceMetadataRequest[],
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<ReconcileInvoiceMetadataResponse[]>> => {
    return axiosInstance.post(
      `/private/support/backfill-invoice-order-numbers`,
      reconcileInvoiceMetadataRequest,
      options,
    )
  }

  /**
   * @summary Backfill all order and subscription related data (order, order_subscription, subscription_billing_cycle)
   */
  const backfillSubscription = (
    backfillSubscriptionRequest: BackfillSubscriptionRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<BackfillSubscriptionResponse>> => {
    return axiosInstance.post(`/private/subscriptions/backfill`, backfillSubscriptionRequest, options)
  }

  /**
   * Schedule a plan switch on the given subscription renewal. At the moment only supports Daily30.
   * @summary Switches the given subscription's plan
   */
  const privateSwitchPlanBySubscriptionId = (
    subscriptionId: string,
    params: PrivateSwitchPlanBySubscriptionIdParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<SwitchOnRenewalResponse>> => {
    return axiosInstance.post(`/private/subscription/${subscriptionId}/switch-plan`, undefined, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Cancel a subscription using the appropriate methodology based on the subscription type
   */
  const privateCancel = (
    subscriptionId: string,
    cancelSubscriptionRequest: CancelSubscriptionRequest,
    params: PrivateCancelParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CancelledSubscriptionDetails>> => {
    return axiosInstance.post(`/private/subscription/${subscriptionId}/cancel`, cancelSubscriptionRequest, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Reinstate auto-renewal for a cancelled subscription by subscription id
   */
  const reinstateAutoRenewalBySubscriptionId = (
    subscriptionId: string,
    params: ReinstateAutoRenewalBySubscriptionIdParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Subscription>> => {
    return axiosInstance.post(`/private/subscription/${subscriptionId}/cancel/reinstate-auto-renewal`, undefined, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * Immediately cancels a subscription with no refund. Prefer the /cancel endpoint which selects the appropriate cancellation strategy based on subscription type.
   * @summary Cancel a subscription immediately by subscription id
   */
  const cancelImmediatelyBySubscriptionId = (
    subscriptionId: string,
    params: CancelImmediatelyBySubscriptionIdParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Subscription>> => {
    return axiosInstance.post(`/private/subscription/${subscriptionId}/cancel/immediate`, undefined, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * The discount is resolved from the subscription's own plan, so the client never names a coupon.
   * @summary Apply the cancellation-save discount to a subscription
   */
  const privateApplyDiscount = (
    subscriptionId: string,
    params: PrivateApplyDiscountParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CancellationDiscount>> => {
    return axiosInstance.post(`/private/subscription/${subscriptionId}/cancel/discount`, undefined, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  const createLinearTicket = (
    createLinearTicketRequest: CreateLinearTicketRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(`/private/linear/tickets`, createLinearTicketRequest, options)
  }

  /**
   * @summary Search gift rules
   */
  const searchGifts = (
    params?: SearchGiftsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<GiftRule[]>> => {
    return axiosInstance.get(`/private/gifts`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Store a gift rule. The rule is created inactive
   */
  const createGift = (
    createGiftRuleRequest: CreateGiftRuleRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<GiftRule>> => {
    return axiosInstance.post(`/private/gifts`, createGiftRuleRequest, options)
  }

  /**
   * Temporary endpoint for inspecting rule evaluation by hand. It will be removed once gifting is wired into checkout and payment completion. Do not build on it.
   * @deprecated
   * @summary DEBUG ONLY: list the gift rules a given purchase qualifies for
   */
  const getApplicableGifts = (
    applicableGiftsRequest: ApplicableGiftsRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<GiftRule[]>> => {
    return axiosInstance.post(`/private/gifts/applicable`, applicableGiftsRequest, options)
  }

  const createPromotionCodeForCoupon = (
    couponId: string,
    promotionCodeCreationRequest: PromotionCodeCreationRequest,
    params: CreatePromotionCodeForCouponParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<PromotionCode>> => {
    return axiosInstance.post(`/private/coupons/${couponId}/promo-codes`, promotionCodeCreationRequest, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  const triggerCheckoutSessionCompletedWebhookProcessing = (
    checkoutSessionCompletedTrigger: CheckoutSessionCompletedTrigger,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(`/private/checkout-session-completed/trigger`, checkoutSessionCompletedTrigger, options)
  }

  /**
   * @summary Refund a charge for a user
   */
  const refundCharge = (
    username: string,
    chargeId: string,
    params?: RefundChargeParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Refund>> => {
    return axiosInstance.post(`/private/billing/${username}/${chargeId}/refund`, undefined, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Get subscription by subscription id
   */
  const getSubscriptionById = (
    subscriptionId: string,
    params?: GetSubscriptionByIdParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Subscription>> => {
    return axiosInstance.get(`/public/subscription/${subscriptionId}`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * Sibling of POST /switch-plan, validated by the same code, so every option returned is a target the switch accepts. Prices at the same billing frequency as the subscription's upcoming cycle are left out. Options are sorted longest billing period first, then most expensive, then lookup key. Returns 200 with an empty list and `cannot_switch_reason` set when the subscription's state blocks a switch, and 200 with an empty list and a null reason when nothing is switchable.
   * @summary Get the plans this subscription can switch to
   */
  const getSwitchOptions = (
    subscriptionId: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<SwitchOptionsResponse>> => {
    return axiosInstance.get(`/public/subscription/${subscriptionId}/switch-options`, options)
  }

  /**
   * @summary Get cancellation interventions available for a subscription
   */
  const getInterventions = (
    subscriptionId: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CancellationInterventionsResponse>> => {
    return axiosInstance.get(`/public/subscription/${subscriptionId}/cancel/interventions`, options)
  }

  /**
   * @summary Fetch subscriptions based on username
   */
  const getSubscriptions = (
    params?: GetSubscriptionsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OrderSubscription[]>> => {
    return axiosInstance.get(`/public/subscription`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Fetch subscriptions based on username
   */
  const getSubscriptions1 = (
    params?: GetSubscriptions1Params,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<OrderSubscription[]>> => {
    return axiosInstance.get(`/public/subscription/`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Get the details of a Stripe Checkout Session
   */
  const getCheckoutSessionDetails = (
    params: GetCheckoutSessionDetailsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<GetCheckoutSessionDetailsResponse>> => {
    return axiosInstance.get(`/public/session/details`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Get product availability for a user
   */
  const getProductsAvailability = (
    params?: GetProductsAvailabilityParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<GetProductsAvailability200>> => {
    return axiosInstance.get(`/public/products/availability`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   *
   *             Country-scoped public price lookup for anonymous browsing (e.g. marketing pages).
   *
   *             Filters:
   *             - `countryCode` (required): country whose prices to return.
   *             - `productType` (optional): narrow to a single ZOE product type.
   *             - `lookupKeys` (optional): narrow the result to specific Stripe lookup keys.
   *             - `visible` (optional): tri-state. `true` keeps only prices tagged `metadata.visible = "true"`
   *               (those listed on plan-select / product pages); `false` keeps only the rest (absent ⇒ false, so
   *               fees, backing add-ons and trial companions match); omit for no filter.
   *             - `live` (optional): tri-state, same semantics over `metadata.live` (this price may be sold).
   *               This is a listing filter only — checkout enforces liveness server-side regardless.
   *             - `switchable` (optional): tri-state, same semantics over `metadata.switchable` (an existing
   *               subscription may move onto this price). Discovery only — the switch endpoint rejects a
   *               non-switchable target regardless of what is requested here.
   *
   *             Omitting `visible`/`live` currently defaults both to `true`, but only when `lookupKeys` is absent;
   *             a keyed query is left unfiltered so that a basket may mix visible prices with fees and companions.
   *             The defaults are removed in ECO-3275 once clients pass the flags explicitly. `switchable` is
   *             exempt from that coercion entirely: it is new, so it has no legacy callers to keep compatible.
   * @summary Fetch prices by country and productType. Unauthenticated.
   */
  const fetchPublicPrices = (
    params: FetchPublicPricesParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<FetchPricesResponse>> => {
    return axiosInstance.get(`/public/prices`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   *
   *             Returns the active prices available to the authenticated user, restricted to the given
   *             `productType`. The user's current plan price for that product type is excluded from the response,
   *             so the result is the set of prices the user could *switch to*.
   *
   *             Prices are read on the market the user's active subscription for that `productType` was sold on,
   *             which is what the switch endpoint enforces against. A user with no active subscription for it is
   *             browsing rather than switching, so their own market is used instead.
   *
   *             Filters:
   *             - `productType` (required): Restricts the result to a single ZOE product type.
   *             - `lookupKeys` (optional): Further narrows the result to the given Stripe lookup keys.
   *             - `visible` (optional): tri-state. `true` keeps only prices tagged `metadata.visible = "true"`
   *               (those listed on plan-select / product pages); `false` keeps only the rest (absent ⇒ false, so
   *               fees, backing add-ons and trial companions match); omit for no filter.
   *             - `live` (optional): tri-state, same semantics over `metadata.live` (this price may be sold).
   *             - `switchable` (optional): tri-state, same semantics over `metadata.switchable` (an existing
   *               subscription may move onto this price). Use it to list switch targets. Discovery only — the
   *               switch endpoint rejects a non-switchable target regardless of what is requested here.
   *
   *             Every filter is independent and unfiltered when omitted — a keyed basket may therefore mix
   *             visible prices with non-visible fees and companions.
   * @summary Get the prices available to the authenticated user for a given product type.
   */
  const getUserAvailablePrices = (
    params: GetUserAvailablePricesParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<FetchPricesResponse>> => {
    return axiosInstance.get(`/public/prices/me`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * Returns what the receiver's redeem page shows and the basket to check out. The promotion code id is only returned while the gift is redeemable.
   * @summary Get a cross customer gift for its redeem page
   */
  const getGiftDetails = (giftOrderId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<unknown>> => {
    return axiosInstance.get(`/public/gift-checkout/gifts/${giftOrderId}`, options)
  }

  const getCustomer = (options?: AxiosRequestConfig): Promise<AxiosResponse<PublicCustomerResponse>> => {
    return axiosInstance.get(`/public/customers/me`, options)
  }

  /**
   * @summary Get billing portal based on username
   */
  const getBillingPortalUrl = (options?: AxiosRequestConfig): Promise<AxiosResponse<BillingPortal>> => {
    return axiosInstance.get(`/public/billing/portal/url`, options)
  }

  /**
   * @summary Filter through user's subscriptions
   */
  const filterUserSubscriptions = (
    params: FilterUserSubscriptionsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<GetSubscriptionsResponse>> => {
    return axiosInstance.get(`/private/subscription`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Get subscription by subscription id
   */
  const privateGetSubscriptionById = (
    subscriptionId: string,
    params?: PrivateGetSubscriptionByIdParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Subscription>> => {
    return axiosInstance.get(`/private/subscription/${subscriptionId}`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * Support-facing twin of the public switch-options endpoint, with the username taken from the query rather than the token. It calls the same service method, so it answers what the member themselves would be offered rather than an approximation of it. Read only, nothing is tracked. The subscription must belong to the given username, same as the private get-by-id endpoint.
   * @summary Get the plans this subscription can switch to, for any user
   */
  const privateGetSwitchOptions = (
    subscriptionId: string,
    params: PrivateGetSwitchOptionsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<SwitchOptionsResponse>> => {
    return axiosInstance.get(`/private/subscription/${subscriptionId}/switch-options`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Get cancellation interventions available for a subscription
   */
  const privateGetInterventions = (
    subscriptionId: string,
    params: PrivateGetInterventionsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CancellationInterventionsResponse>> => {
    return axiosInstance.get(`/private/subscription/${subscriptionId}/cancel/interventions`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Get product availability for a user by username
   */
  const getProductsAvailability1 = (
    params?: GetProductsAvailability1Params,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<GetProductsAvailability1200>> => {
    return axiosInstance.get(`/private/products/availability`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   *
   *             Service-to-service price lookup. Two modes:
   *             - **User-scoped** (`username` set): country resolved from customer record; user's current plan
   *               price excluded; `productType` required. `visible`/`live` default to `true` (current offering);
   *               `switchable` does not default, so a user-scoped read is never narrowed to switch targets
   *               unless asked.
   *             - **Country-scoped** (`username` absent): plain Stripe lookup against `countryCode`. All three
   *               flags default to unfiltered, so ops keep a full view of active prices.
   *
   *             Filters:
   *             - `username`: requires `productType`; `countryCode` ignored if also sent. Set this to emulate the
   *                behaviour of the /public/prices/me endpoint set the `username` field
   *             - `countryCode`: required when `username` is absent.
   *             - `productType`: required with `username`; optional otherwise.
   *             - `lookupKeys`: Filters the result by Stripe lookup keys.
   *             - `visible`: tri-state. `true` keeps only `metadata.visible = "true"` (listed on plan-select /
   *               product pages); `false` keeps only the rest (absent ⇒ false, so fees, backing add-ons and trial
   *               companions match); omit for no filter.
   *             - `live`: tri-state, same semantics over `metadata.live` (this price may be sold). Note this is a
   *               listing filter only — checkout enforces liveness server-side regardless of what is requested here.
   *             - `switchable`: tri-state, same semantics over `metadata.switchable` (an existing subscription may
   *               move onto this price). Never defaults, on either mode. Discovery only — the switch endpoint
   *               rejects a non-switchable target regardless of what is requested here.
   *
   *             Only prices whose lookup key resolves to a known ZOE product type are ever returned;
   *             anything else is skipped with a warning (never an error).
   *
   *             Returns 400 if neither `username` nor `countryCode` is provided, or if `username` is set
   *             without `productType`.
   * @summary Filter prices by lookup keys, product type, country, and (optionally) on behalf of a user.
   */
  const privateFilterPrices = (
    params?: PrivateFilterPricesParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<FetchPricesResponse>> => {
    return axiosInstance.get(`/private/prices`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * Get latest prices for current user filtered by product type. It always filters out the price from the user's current plan for that product type.
   * @deprecated
   * @summary Get latest available prices for a user filtered by product type
   */
  const privateGetAvailablePrices = (
    params: PrivateGetAvailablePricesParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<AvailablePricesResponse>> => {
    return axiosInstance.get(`/private/price`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Search for customers by their Stripe customer IDs
   */
  const searchCustomers = (
    params: SearchCustomersParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<CustomerListResponse>> => {
    return axiosInstance.get(`/private/customer`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  const getCustomer1 = (username: string, options?: AxiosRequestConfig): Promise<AxiosResponse<CustomerResponse>> => {
    return axiosInstance.get(`/private/customer/${username}`, options)
  }

  /**
   * @summary Get past and upcoming payments for a user
   */
  const getPaymentsSummary = (
    username: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<PaymentsSummary>> => {
    return axiosInstance.get(`/private/billing/${username}/payments-summary`, options)
  }

  /**
   * Searches the member's 100 most recent paid invoices, newest first, and returns the most recent charge for the product type that has not already been refunded. Supports: classic (PROGRAM) memberships, DAILY30 and ZOE_PLUS. Null when they have nothing refundable.
   * @summary Get last refundable charge for a user
   */
  const getLastRefundableCharge = (
    username: string,
    params: GetLastRefundableChargeParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<Charge>> => {
    return axiosInstance.get(`/private/billing/${username}/last-refundable-charge`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  /**
   * @summary Archives a promotion code by marking it as inactive, essentially removing it from future use.
   */
  const deletePromotionCode = (
    promoCodeId: string,
    params: DeletePromotionCodeParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(`/private/coupons/promo-codes/${promoCodeId}`, {
      ...options,
      params: { ...params, ...options?.params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
  }

  return {
    movePhysicalProductSubscriptionBillingDate,
    modifySubscriptionItems,
    updateCheckoutSession,
    createCheckoutSession,
    redeemPromoCodeForSubscription,
    movePhysicalProductSubscriptionBillingDateBySubscriptionId,
    privateModifySubscriptionItems,
    updateGift,
    handleWebhooks,
    handleWebhooks1,
    switchPlanBySubscriptionId,
    cancel,
    reinstateAutoRenewal,
    cancelImmediateBySubscriptionId,
    applyDiscount,
    checkEligibility,
    createGifterCheckoutSession,
    sendDueGiftEmails,
    createOneClickCheckout,
    backfillInvoiceOrderNumbers,
    backfillSubscription,
    privateSwitchPlanBySubscriptionId,
    privateCancel,
    reinstateAutoRenewalBySubscriptionId,
    cancelImmediatelyBySubscriptionId,
    privateApplyDiscount,
    createLinearTicket,
    searchGifts,
    createGift,
    getApplicableGifts,
    createPromotionCodeForCoupon,
    triggerCheckoutSessionCompletedWebhookProcessing,
    refundCharge,
    getSubscriptionById,
    getSwitchOptions,
    getInterventions,
    getSubscriptions,
    getSubscriptions1,
    getCheckoutSessionDetails,
    getProductsAvailability,
    fetchPublicPrices,
    getUserAvailablePrices,
    getGiftDetails,
    getCustomer,
    getBillingPortalUrl,
    filterUserSubscriptions,
    privateGetSubscriptionById,
    privateGetSwitchOptions,
    privateGetInterventions,
    getProductsAvailability1,
    privateFilterPrices,
    privateGetAvailablePrices,
    searchCustomers,
    getCustomer1,
    getPaymentsSummary,
    getLastRefundableCharge,
    deletePromotionCode,
  }
}
export type MovePhysicalProductSubscriptionBillingDateResult = AxiosResponse<Subscription>
export type ModifySubscriptionItemsResult = AxiosResponse<Subscription>
export type UpdateCheckoutSessionResult = AxiosResponse<UpdateCheckoutSessionResponse>
export type CreateCheckoutSessionResult = AxiosResponse<CreateCheckoutSessionResponse>
export type RedeemPromoCodeForSubscriptionResult = AxiosResponse<Subscription>
export type MovePhysicalProductSubscriptionBillingDateBySubscriptionIdResult = AxiosResponse<Subscription>
export type PrivateModifySubscriptionItemsResult = AxiosResponse<Subscription>
export type UpdateGiftResult = AxiosResponse<GiftRule>
export type HandleWebhooksResult = AxiosResponse<void>
export type HandleWebhooks1Result = AxiosResponse<void>
export type SwitchPlanBySubscriptionIdResult = AxiosResponse<SwitchOnRenewalResponse>
export type CancelResult = AxiosResponse<CancelledSubscriptionDetails>
export type ReinstateAutoRenewalResult = AxiosResponse<Subscription>
export type CancelImmediateBySubscriptionIdResult = AxiosResponse<Subscription>
export type ApplyDiscountResult = AxiosResponse<CancellationDiscount>
export type CheckEligibilityResult = AxiosResponse<void>
export type CreateGifterCheckoutSessionResult = AxiosResponse<CreateCheckoutSessionResponse>
export type SendDueGiftEmailsResult = AxiosResponse<void>
export type CreateOneClickCheckoutResult = AxiosResponse<CreateCheckoutSessionResponse>
export type BackfillInvoiceOrderNumbersResult = AxiosResponse<ReconcileInvoiceMetadataResponse[]>
export type BackfillSubscriptionResult = AxiosResponse<BackfillSubscriptionResponse>
export type PrivateSwitchPlanBySubscriptionIdResult = AxiosResponse<SwitchOnRenewalResponse>
export type PrivateCancelResult = AxiosResponse<CancelledSubscriptionDetails>
export type ReinstateAutoRenewalBySubscriptionIdResult = AxiosResponse<Subscription>
export type CancelImmediatelyBySubscriptionIdResult = AxiosResponse<Subscription>
export type PrivateApplyDiscountResult = AxiosResponse<CancellationDiscount>
export type CreateLinearTicketResult = AxiosResponse<void>
export type SearchGiftsResult = AxiosResponse<GiftRule[]>
export type CreateGiftResult = AxiosResponse<GiftRule>
export type GetApplicableGiftsResult = AxiosResponse<GiftRule[]>
export type CreatePromotionCodeForCouponResult = AxiosResponse<PromotionCode>
export type TriggerCheckoutSessionCompletedWebhookProcessingResult = AxiosResponse<void>
export type RefundChargeResult = AxiosResponse<Refund>
export type GetSubscriptionByIdResult = AxiosResponse<Subscription>
export type GetSwitchOptionsResult = AxiosResponse<SwitchOptionsResponse>
export type GetInterventionsResult = AxiosResponse<CancellationInterventionsResponse>
export type GetSubscriptionsResult = AxiosResponse<OrderSubscription[]>
export type GetSubscriptions1Result = AxiosResponse<OrderSubscription[]>
export type GetCheckoutSessionDetailsResult = AxiosResponse<GetCheckoutSessionDetailsResponse>
export type GetProductsAvailabilityResult = AxiosResponse<GetProductsAvailability200>
export type FetchPublicPricesResult = AxiosResponse<FetchPricesResponse>
export type GetUserAvailablePricesResult = AxiosResponse<FetchPricesResponse>
export type GetGiftDetailsResult = AxiosResponse<unknown>
export type GetCustomerResult = AxiosResponse<PublicCustomerResponse>
export type GetBillingPortalUrlResult = AxiosResponse<BillingPortal>
export type FilterUserSubscriptionsResult = AxiosResponse<GetSubscriptionsResponse>
export type PrivateGetSubscriptionByIdResult = AxiosResponse<Subscription>
export type PrivateGetSwitchOptionsResult = AxiosResponse<SwitchOptionsResponse>
export type PrivateGetInterventionsResult = AxiosResponse<CancellationInterventionsResponse>
export type GetProductsAvailability1Result = AxiosResponse<GetProductsAvailability1200>
export type PrivateFilterPricesResult = AxiosResponse<FetchPricesResponse>
export type PrivateGetAvailablePricesResult = AxiosResponse<AvailablePricesResponse>
export type SearchCustomersResult = AxiosResponse<CustomerListResponse>
export type GetCustomer1Result = AxiosResponse<CustomerResponse>
export type GetPaymentsSummaryResult = AxiosResponse<PaymentsSummary>
export type GetLastRefundableChargeResult = AxiosResponse<Charge>
export type DeletePromotionCodeResult = AxiosResponse<void>
